import { Container, Graphics } from "pixi.js"

/** Rising mint sparks: repair feedback without moving or tinting wall sprites. */
export const showTileRepairEffect = (surface: Container, location: { x: number; y: number }): Graphics => {
    const effect = new Graphics()
    effect.position.set(location.x, location.y)
    surface.addChild(effect)
    const started = Date.now()
    const duration = 450
    const paint = (progress: number) => {
        effect.clear()
        effect.alpha = 1 - progress
        effect.lineStyle(1.5, 0xcaffd6, 1)
        for (const [x, y] of [[-9, 0], [7, -5], [-2, -13]]) {
            const risingY = y - progress * 13
            effect.moveTo(x - 2, risingY); effect.lineTo(x + 2, risingY)
            effect.moveTo(x, risingY - 2); effect.lineTo(x, risingY + 2)
        }
    }
    paint(0)
    const timer = setInterval(() => {
        const progress = (Date.now() - started) / duration
        if (effect.destroyed || surface.destroyed || !effect.parent || progress >= 1) {
            clearInterval(timer)
            if (!effect.destroyed) {
                effect.parent?.removeChild(effect)
                effect.destroy()
            }
            return
        }
        paint(Math.max(0, progress))
    }, 16)
    return effect
}
